import { combineReducers } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";

import { baseApi } from "./utils/baseApi";
import { authReducer } from "@features/auth/slices";
import { globalErrorReducer } from "@features/error/slices";

import {
    persistConfig,
    authPersistConfig,
} from "./configs/store.config";

const reducer = combineReducers({
    [baseApi.reducerPath]: baseApi.reducer,
    auth: persistReducer(authPersistConfig, authReducer),
    app: globalErrorReducer,

});

export const rootReducer = persistReducer(persistConfig, reducer);
